import { FaLayerGroup } from "react-icons/fa";
import "./FieldsSection3.css";

const fieldsData = [
  {
    id: "ai-multimedia-design-mastery",
    title: "A.I Multimedia Design Mastery",
    image: "/images/home/fields/chung-chi-nghe-quoc-gia/field1.webp",
  },
  {
    id: "wedding-media-studio-business",
    title: "Wedding Media & Studio Business",
    image: "/images/home/fields/chung-chi-nghe-quoc-gia/field2.webp",
  },
  {
    id: "chuyen-doi-so-doanh-nghiep",
    title: "Chuyển đổi số doanh nghiệp",
    image: "/images/home/fields/chung-chi-nghe-quoc-gia/field3.webp",
  },
  {
    id: "digital-marketing",
    title: "Digital Marketing",
    image: "/images/home/fields/chung-chi-nghe-quoc-gia/field4.webp",
  },
  {
    id: "thiet-ke-website-va-app-mobile",
    title: "Thiết kế Website và App Mobile",
    image: "/images/home/fields/chung-chi-nghe-quoc-gia/field5.webp",
  },
  {
    id: "game-hoat-hinh-3d",
    title: "Game & Hoạt hình 3D",
    image: "/images/home/fields/chung-chi-nghe-quoc-gia/field6.webp",
  },
  {
    id: "graphic-designer-pro",
    title: "Graphic Designer Pro",
    image: "/images/home/fields/chung-chi-nghe-quoc-gia/field7.webp",
  },
  {
    id: "thiet-ke-do-hoa-kien-truc-noi-that",
    title: "Thiết kế đồ họa kiến trúc nội thất",
    image: "/images/home/fields/chung-chi-nghe-quoc-gia/field8.webp",
  },
];

const FieldsSection = () => {
  return (
    <section className="fields">
      <div className="fields__container">
        <div className="fields__icon">
          <FaLayerGroup />
        </div>
        {/* <p className="fields__sub-title">ĐÀO TẠO CHỨNG CHỈ QUỐC GIA</p> */}
        <h2 className="fields__title">ĐÀO TẠO CHỨNG CHỈ Nghề QUỐC GIA</h2>

        <div className="fields__cards">
          {fieldsData.map((field) => (
            <div
              key={field.id}
              className="field-card"
              id={field.id}
            >
              <div className="field-card__image">
                <img
                  src={field.image}
                  alt={field.title.replace(/\n/g, " ")}
                  loading="lazy"
                />
              </div>
              <h3 className="field-card__title--v3">
                {field.title.split("\n").map((line, i) => (
                  <span key={i}>
                    {line}
                    {i !== field.title.split("\n").length - 1 && <br />}
                  </span>
                ))}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FieldsSection;
